//import _ from 'lodash';
import { Service } from 'pdk/services';
import axios from 'axios';
import AppConfig from '@/config';

export class AuthService extends Service {
    #api;

    constructor(options) {
        super();

        if (options == null || options == undefined) 
            options = {
                baseURL: null,
                responseType: null,
                headers: null,
            };
        
        this.#api = axios.create({
            baseURL: options.baseURL || AppConfig.api.baseURL || '/api',
            responseType: options.responseType || 'json',
            headers: options.headers || {
                'portalid': AppConfig.context.portalID
            }
        });
    };

    // Helpers
    #normalizePioneerRxUsername(username) {
        // Remove the 'prx_' prefix, if found
        if (/^prx_.*$/i.test(username)) {
            return username.substring(4);
        }

        return username;
    }

    // Authentication
    async authenticate(options) {
        const data = this._extend(options, {
            username: null,
            password: null,
            rememberMe: false,
            persistSession: true
        });

        // Cleanup PioneerRx usernames
        data.username = this.#normalizePioneerRxUsername(data.username);

        const response = await this.#api.post('ops/account/login', data, {
            logging: {
                ignore: [401]
            }
        });
        return response.data;
    }

    // Tokens
    requestAccessToken(options) {
        const data = this._extend(options, {
            refreshToken: null
        });
        let interval = 500,
            count = 0;

        return new Promise((resolve, reject) => {   
            // Throttle and retry if there is a network error.         
            const refreshHandler = setInterval(() => {
                count++;
                if (count > 10) {
                    // Server is unresponsive, cancel and reject
                    clearInterval(refreshHandler);
                    reject();
                }

                this.#api.post('ops/account/refreshtoken/login', {
                    refreshToken: data.refreshToken
                }).then((response) => { 
                    clearInterval(refreshHandler);
                    resolve(response.data.accessToken);
                }).catch((error) => {
                    if (count === 2) 
                        interval = 1000;
                    
                    if (count === 3 || error.message !== 'Network Error') {                        
                        clearInterval(refreshHandler);
                        reject(error);
                    }
                });
            }, interval);
        });
    }

    async expireRefreshToken(options) {
        const data = this._extend(options, {
            accessToken: null,
            refreshToken: null
        });

        return await this.#api.post('ops/account/refreshtoken/expire', {
            refreshToken: data.refreshToken
        }, { headers: {'authorization': `Bearer ${data.accessToken}` } });
    }
}

export default new AuthService();
